import { useActiveAccountId } from '../../contexts';
import { useGetAvailableCustomFieldCountQuery } from '../gql/generated/GetAvailableCustomFieldCount';

export const useAccountCustomFieldsLimit = () => {
  const accountId = useActiveAccountId();
  const { data, loading: isLoading } = useGetAvailableCustomFieldCountQuery({
    variables: { accountId },
    skip: !accountId,
  });

  const availableCustomFieldCount = isLoading
    ? 0
    : data?.account?.availableCustomFieldCount ?? 0;
  const hasCustomFieldsLimitBeenReached = isLoading
    ? true
    : availableCustomFieldCount <= 0;

  return {
    isLoading,
    availableCustomFieldCount,
    hasCustomFieldsLimitBeenReached,
  };
};
